import React from 'react';
import type { FieldValues, SubmitHandler } from 'react-hook-form';
import { FormProvider, useForm } from 'react-hook-form';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import classNames from 'classnames';
import QuickFiltersPopover from '@/components/common/QuickFiltersPopover';

type QuickFilterProps = {
  buttonContent: string | React.ReactNode;
  label: string;
  handleSubmit: SubmitHandler<FieldValues>;
  children: React.ReactNode;
  defaultValues: FieldValues;
};

export default function QuickFilter({
  buttonContent,
  label,
  handleSubmit,
  children,
  defaultValues,
}: QuickFilterProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const open = () => {
    setIsOpen(true);
  };
  const close = () => {
    setIsOpen(false);
  };

  const formMethods = useForm({
    defaultValues,
  });

  const onSubmit = (values: FieldValues) => {
    handleSubmit(values);
    close();
  };

  React.useEffect(() => {
    formMethods.reset(defaultValues);
  }, [defaultValues]);

  return (
    <FormProvider {...formMethods}>
      <Button
        className={classNames(
          { 'bg-grey-100': isOpen },
          'text-base text-text-primary hover:bg-grey-100',
        )}
        type="button"
        onClick={open}
        ref={buttonRef}
        endIcon={<ExpandMoreIcon />}
      >
        {buttonContent}
      </Button>
      <QuickFiltersPopover
        id="quick-filter-constituent-popover"
        open={isOpen}
        anchorEl={buttonRef.current}
        handleClose={close}
        handleSubmit={formMethods.handleSubmit(onSubmit)}
        label={label}
      >
        {children}
      </QuickFiltersPopover>
    </FormProvider>
  );
}
